import React from 'react';
import { schoolYearLabel } from '../utils/schoolYear';

/**
 * Shown INSTEAD of page content when the Academic Calendar says no school
 * year is active (v3.29.0). Teacher pages load no data in this state.
 */
function SchoolYearNotice({ info }) {
  const notStarted = info?.status === 'not_started';
  return (
    <div style={{ maxWidth: '640px', margin: '60px auto', padding: '28px 32px', background: '#fffbeb', border: '1px solid #f59e0b', borderRadius: '12px', textAlign: 'center' }}>
      <div style={{ fontSize: '2em', marginBottom: '10px' }}>🗓️</div>
      <h2 style={{ margin: '0 0 10px', color: '#92400e' }}>The school academic calendar has not started yet</h2>
      {notStarted ? (
        <p style={{ margin: '0 0 8px', color: '#78350f', lineHeight: 1.6 }}>
          The {schoolYearLabel(info.nextStartYear)} school year begins on{' '}
          <strong>{info.nextStartDate instanceof Date ? info.nextStartDate.toLocaleDateString() : String(info.nextStartDate)}</strong>.
          Classes, students, and assessments will be available from that date.
        </p>
      ) : (
        <p style={{ margin: '0 0 8px', color: '#78350f', lineHeight: 1.6 }}>
          No school year is configured for today's date. Please ask your administrator to set the
          quarter dates on the Academic Calendar page.
        </p>
      )}
      <p style={{ margin: 0, color: '#a16207', fontSize: '0.9em' }}>
        If you believe this is a mistake, contact your administrator — the app follows your
        district's Academic Calendar dates.
      </p>
    </div>
  );
}

export default SchoolYearNotice;
